import styled from "styled-components";
import { COLORS, TEXT_COLORS } from "../../constants/design/colors";
import { SPACING, WIDTHS } from "../../constants/design/spacing";

export const PairRow = styled.div`
  display: flex;
  gap: ${SPACING.two}px;
  width: 100%;

  > * {
    flex: 1;
    min-width: 0;
  }

  @media (max-width: ${WIDTHS.S}px) {
    flex-direction: column;
    gap: ${SPACING.three}px;
  }
`;

export const ChevronWrap = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  color: ${TEXT_COLORS.two};
  padding: 0 ${SPACING.two}px;
  cursor: pointer;
`;

export const CheckRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${SPACING.two}px;
  margin-top: ${SPACING.three}px;
`;

export const HelpText = styled.p`
  margin: ${SPACING.three}px 0 0;
  color: ${TEXT_COLORS.three};
  font-size: 12px;
  line-height: 1.5;

  & + & {
    margin-top: ${SPACING.two}px;
  }
`;

/**
 * Stacked, not side-by-side: the modal is only 420px wide on desktop and
 * `calc(100vw - 32px)` on mobile, so a label + segment control + two prices on
 * one line would overflow well before the responsive breakpoint fires.
 */
export const SourceRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${SPACING.two}px;
  margin-bottom: ${SPACING.three}px;
`;

export const SourceHeader = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  justify-content: space-between;
  gap: ${SPACING.two}px;
`;

export const SourceValues = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${SPACING.two}px;
  min-width: 0;
  color: ${TEXT_COLORS.three};
  font-size: 12px;

  > span {
    white-space: nowrap;
  }
`;

export const FieldError = styled.p`
  margin: ${SPACING.two}px 0 0;
  color: ${COLORS.negative.one};
  font-size: 12px;
`;

export const tpTriggerPriceName = "tpTriggerPrice";
export const slTriggerPriceName = "slTriggerPrice";
export const tpRoiName = "tpRoi";
export const slRoiName = "slRoi";
/** Single close size, applied to BOTH legs. */
export const closeSizeName = "tpslCloseSize";
/** Per-leg execution bound; the two legs sit at different levels. */
export const tpLimitPriceName = "tpLimitPrice";
export const slLimitPriceName = "slLimitPrice";
